// This File will be used for checking userid and get authtoken

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, firstValueFrom } from 'rxjs';
import { LoaderService } from '@core-services/loader.service';

import { getRoleApi } from '../../app.config';
import { SharedService } from '@core/services/shared.service';
import { EventMessage, EventType } from '@azure/msal-browser';

@Injectable()
export class AuthService {
  loggedIn: boolean;
  graphLoggedIn = false;
  graphTokenIdleHandler: any;
  url = '';
  public userInfo: any = null;
  public id: any;
  public isIframe: boolean;
  private GraphAPIBaseUrl = 'https://graph.microsoft.com/v1.0/';
  constructor(
    private authService: MsalService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private shared: SharedService
  ) {
    this.isIframe = window !== window.parent && !window.opener;
    if (
      this.authService.instance.getActiveAccount() &&
      this.authService.instance.getActiveAccount()?.username
    ) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }

    this.authService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGOUT_SUCCESS) {
        this.loggedIn = false;
      }
    });

    this.authService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        this.loggedIn = true;
      }
    });
  }

  private checkAndRefreshForNewGraphToken(): void {
    this.checkGraphToken();
    if (!this.graphLoggedIn) {
      this.graphTokenIdleHandler = setInterval(() => {
        if (!this.graphLoggedIn) {
          this.checkGraphToken();
        } else {
          if (
            !localStorage.graphTokenRef &&
            location.href.toLowerCase().indexOf('accessdenied') === -1
          ) {
            localStorage.graphTokenRef = true;
            location.href = location.href;
          } else {
            clearInterval(this.graphTokenIdleHandler);
          }
        }
      }, 500);
    }
  }

  private checkGraphToken(): void {
    const graphToken = this.graphAccessToken(true);
    this.graphLoggedIn = graphToken !== '';
  }

  private getCachedMsalSecret(
    credentialType: 'AccessToken' | 'IdToken',
    targetScope?: string
  ): string {
    const activeAccount = this.authService.instance.getActiveAccount();
    const normalizedScope = targetScope?.toLowerCase();

    for (let index = 0; index < localStorage.length; index++) {
      const storageKey = localStorage.key(index);
      if (!storageKey) {
        continue;
      }

      const storedValue = localStorage.getItem(storageKey);
      if (!storedValue) {
        continue;
      }

      try {
        const parsedValue = JSON.parse(storedValue);
        if (parsedValue?.credentialType !== credentialType) {
          continue;
        }

        if (
          activeAccount?.homeAccountId &&
          parsedValue.homeAccountId &&
          parsedValue.homeAccountId !== activeAccount.homeAccountId
        ) {
          continue;
        }

        if (
          normalizedScope &&
          typeof parsedValue.target === 'string' &&
          !parsedValue.target.toLowerCase().includes(normalizedScope)
        ) {
          continue;
        }

        if (typeof parsedValue.secret === 'string') {
          return parsedValue.secret;
        }
      } catch {
        continue;
      }
    }

    return '';
  }

  login(): void {
    this.authService.loginRedirect({
      scopes: environment.msalLoginReq.scopes,
    });
  }

  logout(): void {
    localStorage.removeItem('graphTokenRef');
    this.authService.logoutRedirect();
  }

  getToken(): string {
    return this.getCachedMsalSecret('IdToken');
  }
  getCurrentUserRole(userGroup: unknown): Promise<unknown> {
    const data = { roles: userGroup };
    return firstValueFrom(
      this.http.post(environment.entryAPI + getRoleApi, data)
    );
  }
  graphAccessToken(strict = false): any {
    const accessToken = this.getCachedMsalSecret('AccessToken', 'user.read');

    if (accessToken) {
      return accessToken;
    }

    return strict ? '' : this.getToken();
  }
  // check the permission for all the available menu
  checkPermission(role: string, url: string): boolean {
    let userPermission: any[] = [];
    const subscription = this.shared.userPermission.subscribe((data) => {
      userPermission = data ?? [];
    });
    subscription.unsubscribe();
    const flags = [];
    const urlArray = [];
    const l = userPermission.length;
    let i;
    if (url === '/demo') {
      return true;
    }
    for (i = 0; i < l; i++) {
      if (flags[userPermission[i].name]) {
        continue;
      }
      flags[userPermission[i].name] = true;
      if (userPermission[i].route_url.includes(',')) {
        urlArray.push(...userPermission[i].route_url.split(','));
      } else {
        urlArray.push(userPermission[i].route_url);
      }
    }
    if (url.includes('/imagedetails')) {
      url = '/imagedetails';
    }
    if (url === '/') {
      url = '/home';
    }

    if (urlArray && urlArray.length > 0) {
      if (urlArray.includes(url)) {
        return true;
      }
      return false;
    }

    return false;
  }
  public async getMemberList(): Promise<object> {
    const res = new Promise<object>((resolve, reject) => {
      const headers: HttpHeaders = new HttpHeaders();

      this.http
        .get(
          this.GraphAPIBaseUrl +
            'groups/' +
            'b934fdc4-56b7-4aa8-af47-c9f64a3a73e9' +
            '/members',
          { headers }
        )
        .subscribe((err: any) => {
          console.log('error', err);
          if (
            err.error.error &&
            err.error.error.code === 'InvalidAuthenticationToken'
          ) {
          } else {
          }
        });
    });

    return res;
  }

  public async isTokenValid(): Promise<boolean> {
    const res = new Promise<boolean>((resolve, reject) => {
      const headers: HttpHeaders = new HttpHeaders();

      this.http.get(this.GraphAPIBaseUrl + 'me', { headers }).subscribe(
        (resp: any) => {
          if (resp.error && resp.code === 'InvalidAuthenticationToken') {
            resolve(false);
          } else {
            resolve(true);
          }
        },
        (err: any) => {
          if (
            err.error.error &&
            err.error.error.code === 'InvalidAuthenticationToken'
          ) {
            resolve(false);
          } else {
            resolve(true);
          }
        }
      );
    });

    return res;
  }

  getExpiry(): any {
    this.id = this.authService.instance.getActiveAccount()?.idTokenClaims?.exp;
    return this.id * 1000;
  }

  // added menber list api hear for checking.
  getProfile(): any {
    return this.authService.instance.getActiveAccount()?.idTokenClaims;
  }
  getCurrentUserId(): any {
    return this.authService.instance.getActiveAccount()?.username;
  }

  getUserId(): number {
    const roleId = 1;
    return roleId;
  }
  async getMemberListfunction(): Promise<any> {
    await this.getMemberList();
  }

  async checkLog(): Promise<void> {
    if (
      this.authService.instance.getActiveAccount()?.username != null &&
      !(await this.isTokenValid())
    ) {
      localStorage.removeItem('graphTokenRef');
      this.checkAndRefreshForNewGraphToken();
      this.loaderService.show();
    }
  }

  getMlTokenSilent(): Observable<any> {
    const tokenRequest = environment.msalTokenReq;
    return new Observable((observer) => {
      try {
        if (this.tokenExpired()) {
          this.authService.instance
            .acquireTokenSilent(tokenRequest)
            .then((res) => {
              localStorage.setItem('mltoken', res.accessToken);
              localStorage.setItem(
                'tokenExpiryTime',
                res?.expiresOn?.toString() ?? ''
              );
              observer.next(res.accessToken);
              observer.complete();
            })
            .catch(() => {
              this.getTokenLogin().subscribe((response) => {
                observer.next(response.mlToken);
                observer.complete();
              });
            });
        } else {
          observer.next(localStorage.getItem('mltoken'));
          observer.complete();
        }
      } catch (err) {
        observer.error(err);
      }
    });
  }

  getTokenLogin(): Observable<any> {
    const loginRequest = environment.msalLoginReq;
    return new Observable((observer) => {
      try {
        this.authService.instance
          .loginPopup(loginRequest)
          .then(() => {
            const tokenRequest = environment.msalTokenReq;
            this.authService.instance
              .acquireTokenSilent(tokenRequest)
              .then((res) => {
                localStorage.setItem('mltoken', res.accessToken);
                localStorage.setItem(
                  'tokenExpiryTime',
                  res?.expiresOn?.toString() ?? ''
                );
                observer.next({ status: true, mlToken: res.accessToken });
                observer.complete();
              })
              .catch((err) => {
                console.log('RESPONSE IN ERROR TOKEN', err);
                observer.next({ status: false, mlToken: null });
                observer.complete();
              });
          })
          .catch((err) => {
            console.log('err', err);
            observer.next({ status: false, mlToken: null });
            observer.complete();
          });
      } catch (err) {
        observer.error(err);
      }
    });
  }

  tokenExpired(): boolean {
    const tokenExpiryTimeValue = localStorage.getItem('tokenExpiryTime');
    if (!tokenExpiryTimeValue) {
      return true;
    } else {
      const tokenExpiryTime = new Date(tokenExpiryTimeValue);
      const timeDiff = new Date().getTime() - tokenExpiryTime.getTime();
      if (timeDiff > 0) {
        return true;
      }
    }
    return false;
  }

  // calculating session expiry time in sec
  calculateExpirySec(): number {
    let expirySecond = 3600;
    const expiryValue: any =
      this.authService.instance.getActiveAccount()?.idTokenClaims?.exp;
    if (expiryValue !== null && expiryValue !== 0) {
      const exp = expiryValue * 1000;
      const expTime = new Date(exp).getTime();
      const currTime = new Date().getTime();
      const diff = expTime - currTime;
      expirySecond = diff / 1000;
    }

    if (!Number.isFinite(expirySecond) || expirySecond <= 0) {
      expirySecond = 3600;
    }

    return Math.floor(expirySecond);
  }
}
